import React from 'react';
import {View, Text, TouchableOpacity, StyleSheet, Image} from 'react-native';
import {navigationRef} from 'src/Nav/navigationHelpers';
import UserIcon from 'src/HeaderComponents/UserIcon';

const styles = StyleSheet.create({
  container: {
    marginHorizontal: 10,
    marginVertical: 10,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
  },
  hamburgerRow: {
    backgroundColor: global?.color?.orange,
    height: 3,
    borderRadius: 2,
    margin: 3,
  },
});

export const MainIcon = ({handlePress}) => {
  return (
    <TouchableOpacity
      onPress={handlePress}
      disabled={!handlePress}
      style={styles.container}>
      <Image
        style={{height: 40, width: (40 * 2083) / 875, resizeMode: 'contain'}}
        source={require('src/Images/logo4.png')}
        // resizeMode={FastImage?.resizeMode?.contain}
      />
    </TouchableOpacity>
  );
};

export const Hamburger = ({handlePress, collapsed}) => {
  const rowWidth = collapsed ? 4 : 30;
  return (
    <TouchableOpacity
      style={styles.container}
      activeOpacity={0.8}
      onPress={handlePress}>
      <View style={[styles.hamburgerRow, {width: rowWidth}]}>
        <Text />
      </View>
      <View style={[styles.hamburgerRow, {width: rowWidth}]}>
        <Text />
      </View>
      <View style={[styles.hamburgerRow, {width: rowWidth}]}>
        <Text />
      </View>
    </TouchableOpacity>
  );
};

export const PageTitle = ({text}) => {
  return (
    <View style={styles.container}>
      <Text
        style={{
          color: global?.color?.orange,
          fontFamily: global?.font.circular,
          fontSize: 18,
          fontWeight: '700',
        }}>
        {text}
      </Text>
    </View>
  );
};

// used for fake navigators
export const SimpleHeaderBar = ({showScore = false, score = 0}) => {
  return (
    <View
      style={{
        flexDirection: 'row',
        backgroundColor: 'white',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}>
      <View>
        <UserIcon />
      </View>
      <MainIcon
        handlePress={() => {
          navigationRef.navigate('LandingPageMain', null, 'Header Component');
        }}
      />
      {!!showScore && (
        <View
          style={{
            backgroundColor: global?.color?.orange,
            marginRight: 5,
            paddingVertical: 5,
            paddingHorizontal: 10,
            height: 30,
          }}>
          <Text
            style={{
              color: global?.color?.white,
              fontFamily: global?.font.circular,
            }}>
            {`${score.toLocaleString()} pts`}
          </Text>
        </View>
      )}
      {!showScore && (
        <View
          style={{
            backgroundColor: global?.color?.orange,
            marginRight: 5,
            paddingVertical: 5,
            paddingHorizontal: 10,
            height: 30,
          }}></View>
      )}
    </View>
  );
};
